import { Box, IconButton, Typography } from "@mui/material";
import GridOnIcon from "@mui/icons-material/GridOn";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import React from "react";
import { Export4PLExportPartner,getFourPLDataFrance } from "../analyzeSlice";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectColumns from "./MultiSelectColumns";

export default function ExportFourPLData() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	
	const { fourPLDataPrepared, 
			selectedColumns,
			selectedCountryID,
			selectedCountry,
			duration4PL,
			isDisPlayExport,
			fourPLDataFrance,
		} = state;
	const { rows, columns } = fourPLDataPrepared;
debugger;
	console.log(rows, selectedColumns);

	function exportDataAsFile(isPdf) {
debugger;
console.log(selectedColumns);
let filteredArray=[];
if(selectedCountry==='France'){
	const obj = {
		countryID: selectedCountryID,
		duration4PL,
	};
	
	dispatch(getFourPLDataFrance(obj)).then((response)=>{
		debugger;
		filteredArray = response.payload;		
		const obj = {
			AnalyzeTitle: "Analyze: 4PL Export Partner",
			CountryID: selectedCountryID,
			CountryName: selectedCountry,
			period: duration4PL,
			listAnalyze4PLTableData: filteredArray
		};		
		dispatch(Export4PLExportPartner(obj));
	})
}
else{
	console.log(rows, selectedColumns);
		 filteredArray = rows.map(obj => {
			const filteredObj = {};
			selectedColumns.forEach(key => {
			  if (obj.hasOwnProperty(key)) {
				filteredObj[key] = obj[key];
			  }
			});
			return filteredObj;
		  });

		  const renamedArray = filteredArray.map(item => {
			return {
				'Country':item.country,
				'Customer Name': item.customerName,
				'Customer Number': item.customerNumber,
				'Customer Type': item.customerType,
				'Customer Group Name': item.customerGroupName,
				'Customer Group Number': item.customerGroupNumber,
				'Partnership': item.partnerType,
				'Quota': item.quota,
				'Product Number': item.productNumber,
				'Product Name': item.productName,
				'Product Group Name': item.productGroupName,
				'Product Group Number': item.productGroupNumber,
				'Start Date': item.startDate,
				'End Date': item.endDate,
				'Period Type': item.periodType,
			};
		});

		  console.log(filteredArray)

		const obj = {
			AnalyzeTitle: "Analyze: 4PL Export Partner",
			CountryID: selectedCountryID,
			CountryName: selectedCountry,
			period: duration4PL,
			listAnalyze4PLTableData: renamedArray
		};
		dispatch(Export4PLExportPartner(obj));		
		
	}

	}

	return (
		<Box
			sx={{
				mt: 3,
				display: "flex",
				flexDirection: "row",
				justifyContent: "flex-start",
			}}
		>
			<Typography variant="subtitle1" sx={{ color: "darkred.light", mt: 1, mr: 2,}}>
				Analyze 4 PL Data
			</Typography>

			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-start",
				}}
			>
				{isDisPlayExport && <MultiSelectColumns columns={columns}/>}
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-end",
					ml: "calc(100% - 550px)",
				}}
			>
				<IconButton onClick={(e) => exportDataAsFile(false)}>
					<GridOnIcon sx={{ color: "green.main" }} />
				</IconButton>
				{/* <IconButton onClick={(e) => exportDataAsFile(true)}>
					<PictureAsPdfIcon sx={{ color: "red.main" }} />
				</IconButton> */}
			</Box>
		</Box>
	);
}
